import { createElement } from "../../../utils/DOMutils";
import {
    getElementParentRow,
    addChangeEventListener,
    addFocusEventListener,
} from "../../../utils/formHelpers";
import { messages } from "../utils";

export const handleDefaultStateAndLabelFormRows = (form) => {
    const formElements = form.elements;
    form.classList.add("form__form");

    for (const element of formElements) {
        const parentRow = getElementParentRow(element, "mktoFormRow");

        if (!parentRow) return;

        const tagName = element.tagName.toLowerCase();

        if (tagName !== "fieldset") {
            const labels = parentRow.querySelectorAll("label");

            if (labels[0]) labels[0].classList.add("form__field-label");

            if (labels[1]) labels[1].classList.add("form__field-check");

            element.classList.add("form__field-value");
        }

        parentRow.classList.add("form__field", `form__field--${tagName}`);

        if (element instanceof HTMLInputElement && element.getAttribute("type"))
            parentRow.classList.add(`form__field--${element.getAttribute("type")}`);

        if (element.getAttribute("name"))
            parentRow.classList.add(
                `form__field--${element.getAttribute("name")}`,
                `mktoFormRow--${element.getAttribute("name")}`
            );

        if (element.value && element.value !== "") parentRow.classList.add("form__field--filled");
    }
};

const transformSubmitButton = (form) => {
    const submitButton = form.querySelector("button[type='submit']");

    if (!submitButton) return;

    const arrow = createElement("span", { class: "link-button__arrow" });

    submitButton.classList.add("form__submit", "link-button", "link-button--full", "link-button--no-arrow");
    submitButton.appendChild(arrow);
};

export const translateRecaptchaDisclaimer = (form) => {
    const el = form.querySelector(".mktoCaptchaDisclaimer");

    if (!el) return;

    el.innerHTML = messages.recaptchaDisclaimer;
};

const makeFormVisible = (form) => (form.style.visibility = "visible");

export default function(formElement) {
    addChangeEventListener(formElement);
    addFocusEventListener(formElement);
    transformSubmitButton(formElement);
    translateRecaptchaDisclaimer(formElement);
    makeFormVisible(formElement);
}
